export const ticketsData = [
  {
    key: "1",
    TICKETCODE: "#TCKT001",
    CREATEDBY: "Andrew Simons",
    CREATEDIMAGE: "avatar-20.jpg",
    SUBJECT: "Payment Issue",
    CREATEDDATE: "24 Jan 2025",
    PRIORITY: "Low",
    ASSIGNEE: "Shaun Farley",
    ASSIGNEEIMAGE: "avatar-38.jpg",
    STATUS: "Resolved",
  },
  {
    key: "2",
    TICKETCODE: "#TCKT002",
    CREATEDBY: "David Steiger",
    CREATEDIMAGE: "avatar-21.jpg",
    SUBJECT: "Car Not Available",
    CREATEDDATE: "19 Dec 2024",
    PRIORITY: "Medium",
    ASSIGNEE: "Jenny Ellis",
    ASSIGNEEIMAGE: "avatar-12.jpg",
    STATUS: "Inprogress",
  },
  {
    key: "3",
    TICKETCODE: "#TCKT003",
    CREATEDBY: "Virginia Phu",
    CREATEDIMAGE: "avatar-12.jpg",
    SUBJECT: "Late Pickup Issue",
    CREATEDDATE: "11 Dec 2024",
    PRIORITY: "High",
    ASSIGNEE: "Leon Baxter",
    ASSIGNEEIMAGE: "avatar-30.jpg",
    STATUS: "Resolved",
  },
  {
    key: "4",
    TICKETCODE: "#TCKT004",
    CREATEDBY: "Walter Hartmann",
    CREATEDIMAGE: "avatar-22.jpg",
    SUBJECT: "Wrong Car Delivered",
    CREATEDDATE: "29 Nov 2024",
    PRIORITY: "Low",
    ASSIGNEE: "Karen Flores",
    ASSIGNEEIMAGE: "avatar-31.jpg",
    STATUS: "Open",
  },
  {
    key: "5",
    TICKETCODE: "#TCKT005",
    CREATEDBY: "Andrea Jermaine",
    CREATEDIMAGE: "avatar-27.jpg",
    SUBJECT: "Accidental Damage Report",
    CREATEDDATE: "03 Nov 2024",
    PRIORITY: "Medium",
    ASSIGNEE: "Michael Dawson",
    ASSIGNEEIMAGE: "avatar-32.jpg",
    STATUS: "Resolved",
  },
  {
    key: "6",
    TICKETCODE: "#TCKT006",
    CREATEDBY: "Dennis Eckhardt",
    CREATEDIMAGE: "avatar-05.jpg",
    SUBJECT: "Refund Request",
    CREATEDDATE: "31 Oct 2024",
    PRIORITY: "High",
    ASSIGNEE: "Karen Galvan",
    ASSIGNEEIMAGE: "avatar-33.jpg",
    STATUS: "Inprogress",
  },
  {
    key: "7",
    TICKETCODE: "#TCKT007",
    CREATEDBY: "Lan Adams",
    CREATEDIMAGE: "avatar-25.jpg",
    SUBJECT: "Extension Request",
    CREATEDDATE: "15 Oct 2024",
    PRIORITY: "Low",
    ASSIGNEE: "Thomas Ward",
    ASSIGNEEIMAGE: "avatar-34.jpg",
    STATUS: "Resolved",
  },
  {
    key: "8",
    TICKETCODE: "#TCKT008",
    CREATEDBY: "Ann Crump",
    CREATEDIMAGE: "avatar-28.jpg",
    SUBJECT: "Unable to Apply Coupon",
    CREATEDDATE: "26 Sep 2024",
    PRIORITY: "Medium",
    ASSIGNEE: "Aliza Duncan",
    ASSIGNEEIMAGE: "avatar-35.jpg",
    STATUS: "Closed",
  },
  {
    key: "9",
    TICKETCODE: "#TCKT009",
    CREATEDBY: "Julie Black",
    CREATEDIMAGE: "avatar-07.jpg",
    SUBJECT: "Overcharge on Invoice",
    CREATEDDATE: "01 Sep 2024",
    PRIORITY: "High",
    ASSIGNEE: "James Higham",
    ASSIGNEEIMAGE: "avatar-36.jpg",
    STATUS: "Resolved",
  },
  {
    key: "10",
    TICKETCODE: "#TCKT0010",
    CREATEDBY: "Jean Walker",
    CREATEDIMAGE: "avatar-29.jpg",
    SUBJECT: "GPS Not Working",
    CREATEDDATE: "15 Aug 2024",
    PRIORITY: "Low",
    ASSIGNEE: "Jade Robinson",
    ASSIGNEEIMAGE: "avatar-37.jpg",
    STATUS: "Resolved",
  },
];
